import { render, staticRenderFns } from "./WeeklyMenuDrawer.vue?vue&type=template&id=9a80a67c&"
import script from "./WeeklyMenuDrawer.vue?vue&type=script&lang=js&"
export * from "./WeeklyMenuDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports